import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Footer.module.scss";
import Button from "../../components/shared/Button/MainButton";
import light_logo from "../../assets/images/footer/icons/logo_footer.svg";
import faceb from "../../assets/images/footer/icons/facebook.svg";
import insta from "../../assets/images/footer/icons/insta.svg";
import ios from "../../assets/images/qr/iOS.svg";
import android from "../../assets/images/qr/android.svg";
import wp from "../../assets/images/footer/icons/whatsapp.svg";
import phone_footer from "../../assets/images/footer/icons/phone_footer.svg";
import HomeServices from "../../pages/home/homeService/HomeService";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import FooterService from "./footerServices/FooterServices";
import tiktokIcon from "../../assets/images/footer/icons/tiktok.svg";
import { Modal } from "antd";
import { useSubscribe } from "../../hooks/useFooterMutations";

interface Partner {
  id: number;
  name: string;
  logo: string;
}
export interface SocialItem {
  id: number;
  key: string;
  value: string;
}

const Footer = () => {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const [allPartners, setAllPartners] = useState<Partner[]>([]);
  const [socialAccounts, setSocialAccount] = useState<SocialItem[]>([]);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const location = useLocation();

  // TanStack Query mutation
  const subscribeMutation = useSubscribe();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await HomeServices.AllPartners();
        setAllPartners(res.partners);
      } catch (error) { }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await FooterService.AllFooterSocialAccounts();
        setSocialAccount(res.data.data);
      } catch (error) { }
    };

    fetchData();
  }, []);
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );
  const footer_links = [
    {
      category: translations?.informations,
      items: [
        {
          name: translations?.blog,
          path: "blog",
        },
        {
          name: translations?.campaigns,
          path: "campaigns",
        },
        // {
        //   name: translations?.news,
        //   path: "/news",
        // },
        {
          name: translations?.videoTutorials,
          path: "videoTutorials",
        },
      ],
    },
    {
      category: translations?.services,
      items: [
        {
          name: translations?.services,
          path: "services",
        },
        {
          name: translations?.apply,
          path: "applyService",
        },
        {
          name: translations?.warrantyTerms,
          path: "warrantyTerms",
        },
      ],
    },
    {
      category: "BSC",
      items: [
        {
          name: translations?.contact,
          path: "/contact",
        },
        {
          name: translations?.about_us,
          path: "about",
        },
        {
          name: translations?.career,
          path: "career",
        },
        {
          name: translations?.privacy_policy,
          path: "privacy-policy",
        },
      ],
    },
  ];

  const whatsapp = socialAccounts.find((item: any) =>
    item.key.toLowerCase().includes("whatsap")
  );
  const instagram = socialAccounts.find((item: any) =>
    item.key.toLowerCase().includes("instagram")
  );
  const facebook = socialAccounts.find((item: any) =>
    item.key.toLowerCase().includes("facebook")
  );
  const tiktok = socialAccounts.find((item: any) =>
    item.key.toLowerCase().includes("tiktok")
  );

  // Email validasiyası
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Subscribe form submit handler
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailError("");

    // TanStack Query mutation istifadə et
    subscribeMutation.mutate(email.trim(), {
      onSuccess: (response) => {
        if (response.status === 200 || response.status === 201) {
          Modal.success({
            title: translations?.success || "Uğurlu",
            content: translations?.subscribe_success || "Abunə oldunuz!",
            okText: translations?.okay || "Tamam",
          });
          setEmail("");
        }
      },
      onError: (error: any) => {
        if (error.response && error.response.status === 422) {
          const backendErrors = error.response.data.errors;
          if (backendErrors.email) {
            setEmailError(backendErrors.email[0]);
          } else {
            setEmailError(translations?.error || "Xəta baş verdi");
          }
        } else {
          Modal.error({
            title: translations?.error || "Xəta",
            content:
              translations?.subscribe_error || "Abunə olarkən xəta baş verdi",
            okText: translations?.okay || "Tamam",
          });
        }
      },
    });
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError("");
    }
  };

  return (
    <footer id={styles.footer}>
      {location.pathname === "/" && (
        <div className={styles.partners_section}>
          <div className="container">
            <div className={styles.our_partners}>
              <div className={styles.content}>
                <h1 className={styles.partners_title}>
                  {translations.dear_partners}
                </h1>
                <p className={styles.partners_subtitle}>
                  {translations.text_for_partners}
                </p>
              </div>
              <div className={styles.partners}>
                {allPartners.length === 0 ? (
                  // Skeleton state to reserve space
                  <div className={styles.partners_skeleton}>
                    <div className={styles.spare_partners}>
                      {[1, 2, 3].map((i) => (
                        <div key={i} className={styles.partner_card_skeleton} />
                      ))}
                    </div>
                    <div className={styles.spare_partners}>
                      {[1, 2].map((i) => (
                        <div key={i} className={styles.partner_card_skeleton} />
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className={styles.spare_partners}>
                      {allPartners.map(
                        (partner: any, index: number) =>
                          index % 2 === 0 && (
                            <div key={index} className={styles.partner_card}>
                              <img
                                src={partner.logo}
                                alt={`partner-${index}`}
                                width="160"
                                height="100"
                                loading="lazy"
                              />
                            </div>
                          )
                      )}
                    </div>
                    <div className={styles.spare_partners}>
                      {allPartners.map(
                        (partner: any, index: number) =>
                          index % 2 !== 0 && (
                            <div key={index} className={styles.partner_card}>
                              <img
                                src={partner.logo}
                                alt={`partner-${index}`}
                                width="160"
                                height="100"
                                loading="lazy"
                              />
                            </div>
                          )
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.footer_top}>
        <div className="container">
          <div className={styles.footer_top_content}>
            <div className={styles.subscribe_us}>
              <p className={styles.subscribe_title}>
                {translations.your_partner}
              </p>
              <form
                onSubmit={handleSubscribe}
                className={styles.subscribe_form}
              >
                <div className={styles.input_control}>
                  <input
                    type="email"
                    name="email"
                    id="subscribe-email"
                    placeholder={translations.email}
                    value={email}
                    onChange={handleEmailChange}
                    onInput={(e: any) => {
                      const target = e.target;
                      target.setCustomValidity("");
                      if (target.validity.valueMissing) {
                        target.setCustomValidity(
                          translations?.enter_email || "Zəhmət olmasa doldurun"
                        );
                      } else if (target.validity.typeMismatch) {
                        target.setCustomValidity(
                          translations?.invalid_email || "Zəhmət olmasa düzgün email daxil edin"
                        );
                      }
                    }}
                    onInvalid={(e: any) => {
                      const target = e.target;
                      if (target.validity.valueMissing) {
                        target.setCustomValidity(
                          translations?.enter_email || "Zəhmət olmasa doldurun"
                        );
                      } else {
                        target.setCustomValidity(
                          translations?.invalid_email || "Zəhmət olmasa düzgün email daxil edin"
                        );
                      }
                    }}
                    required
                    disabled={subscribeMutation.isPending}
                  />
                  {emailError && (
                    <span className={styles.error_message}>{emailError}</span>
                  )}
                </div>
                <div className={styles.form_btn}>
                  <Button
                    text={
                      subscribeMutation.isPending
                        ? translations?.loading || "Göndərilir..."
                        : translations.subscribe
                    }
                    className={styles.subscribe_btn}
                    type="submit"
                    disabled={subscribeMutation.isPending}
                  ></Button>
                </div>
              </form>
              <a href="tel:991" className={styles.footerPhone}>
                <img
                  className={styles.phoneIconFooter}
                  src={phone_footer}
                  alt="call"
                  width="44"
                  height="44"
                />
                <p
                  className={`${styles.headerPhone_num} ${theme === "dark" ? styles.headerPhone_num_dark : ""
                    }`}
                >
                  991
                </p>
              </a>
            </div>
            <div className={styles.footer_navlinks}>
              <div className={styles.category}>
                <h2 className={styles.category_title}>
                  {translations?.informations}
                </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find(
                      (section) =>
                        section.category === translations?.informations
                    )
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.category}>
                <h2 className={styles.category_title}>
                  {translations.services}
                </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find(
                      (section) => section.category === translations?.services
                    )
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.category}>
                <h2 className={styles.category_title}>Baku Service Company </h2>
                <ul className={styles.navlinks_lists}>
                  {footer_links
                    .find((section) => section.category === "BSC")
                    ?.items.map((item, idx) => (
                      <li key={idx} className={styles.nav_item}>
                        <Link className={styles.footer_link} to={item.path}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer_bottom}>
        <div className="container">
          <div className={styles.footer_bottom_content}>
            <div className={styles.footer_logo}>
              <Link to={"/"}>
                <img src={light_logo} alt="logo" width="200" height="140" />
              </Link>
            </div>
            <div className={styles.smedia_rights}>
              {/* <div className={styles.social_media}>
                <div className={styles.icon_box}>
                  <img src={wp} alt="" />
                </div>
                <div className={styles.icon_box}>
                  <img src={insta} alt="" />
                </div>
                <div className={styles.icon_box}>
                  <img src={faceb} alt="" />
                </div>
              </div> */}
              <div className={styles.qr_box}>
                {/* Sol tərəf - mətn */}

                {/* Sağ tərəf - QR kodlar */}
                <div className={styles.qr_box_content}>
                  <div className={styles.qr_text_wrapper}>
                    <p
                      className={`${styles.scan_app_text} ${theme === "light" ? styles.light_mode : ""
                        }`}
                    >
                      Scan et, tətbiqi yüklə <br /> yeniliklərdən xəbərdar ol
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <img
                        src={ios}
                        alt="iOS QR"
                        style={{
                          width: "100px",
                          height: "100px",
                          marginBottom: "5px",
                        }}
                      />
                      <p style={{ fontSize: "14px", color: "#fff", margin: 0 }}>
                        iOS
                      </p>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <img
                        src={android}
                        alt="Android QR"
                        style={{
                          width: "100px",
                          height: "100px",
                          marginBottom: "5px",
                        }}
                      />
                      <p style={{ fontSize: "14px", color: "#fff", margin: 0 }}>
                        Android
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.social_media}>
                {tiktok?.value && (
                  <a
                    href={tiktok.value}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles.icon_box}>
                      <img src={tiktokIcon} alt="tiktok" width="24" height="24" />
                    </div>
                  </a>
                )}
                {whatsapp?.value && (
                  <a
                    href={whatsapp.value}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles.icon_box}>
                      <img src={wp} alt="whatsapp" width="24" height="24" />
                    </div>
                  </a>
                )}
                {instagram?.value && (
                  <a
                    href={instagram.value}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles.icon_box}>
                      <img src={insta} alt="instagram" width="24" height="24" />
                    </div>
                  </a>
                )}
                {facebook?.value && (
                  <a
                    href={facebook.value}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={styles.icon_box}>
                      <img src={faceb} alt="facebook" width="24" height="24" />
                    </div>
                  </a>
                )}
              </div>

              <div className={styles.copy_rights}>
                <p
                  className={`${styles.scan_app_text} ${theme === "light" ? styles.light_mode : ""
                    }`}
                >
                  {translations.copy_right_text}
                </p>
                <p
                  className={`${styles.scan_app_text} ${theme === "light" ? styles.light_mode : ""
                    }`}
                >
                  © Baku Service Company {new Date().getFullYear()}
                </p>
                {/* <a href="/warrantyTerms">{translations.warrantyTerms}</a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
